<div class="_digicheques-usage-statistic-component">

	<statistic-component 
		title="STATISTICS.BEEGO.DIGICHEQUES.TITLE"
		subtitle="{{'STATISTICS.BEEGO.DIGICHEQUES.SUBTITLE' | translate}}"
		explanation="STATISTICS.BEEGO.DIGICHEQUES.EXPLANATION"
		[chartType]="'pie'"
		[dataRequest]="dataRequest"
		[params]="params"
		[canToggleLegend]="true"
	>
	</statistic-component>

</div>



